import { useCallback, useEffect, useState } from 'react';

type ForgeTheme = 'dark' | 'light';

const STORAGE_KEY = 'forge-theme';

function getPreferred(): ForgeTheme {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'dark' || stored === 'light') return stored;
  return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
}

export function useForgeTheme() {
  const [theme, setTheme] = useState<ForgeTheme>(getPreferred);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((t) => (t === 'dark' ? 'light' : 'dark'));
  }, []);

  return { theme, toggleTheme } as const;
}
